// extracted by mini-css-extract-plugin
export default {"districtOperation":"editop_districtOperation__MhrdA"};